export default {
  /**
   * The help text to render.
   * 
   * @param {String}
   */
  helpText: ''
}